import React, { useRef } from 'react'
import { useSmallerScreen } from 'hooks'
import { CampaignTemplateCategoryTab } from 'components/business'
import { useWindowEvent, useWindowScroll } from '@mantine/hooks'
import { Affix, Center, Group, Transition } from '@mantine/core'
import { CampaignTemplateCategory } from 'types/domain'

const CategoryAffixTab = () => {
  const tabRef = useRef<any>(null)
  const smallerScreen = useSmallerScreen()
  const [scroll, scrollTo] = useWindowScroll()
  const scrollY = smallerScreen ? 330 : 380

  const handleChange = (category: CampaignTemplateCategory, option: ScrollToOptions) => {
    scrollTo({ y: option.top! - 190 })
  }

  const handleScroll = () => {
    tabRef?.current?.onScroll(100)
  }

  useWindowEvent('scroll', handleScroll)

  return (
    <Group spacing="xl" className="relative">
      <Affix position={{ top: '57px' }} zIndex={1002}>
        <Transition transition="fade" mounted={scroll.y > scrollY}>
          {(transitionStyles) => (
            <Center
              className="sm:h-[56px] h-[114px]"
              sx={(theme) => ({
                width: '100vw',
                background: 'white',
                opacity: '0.8',
                height: '56px',
                borderBottom: `1px solid ${theme.colors.gray[2]}`,
                backdropFilter: 'blur(10px)',
              })}
              style={transitionStyles}
            >
              <CampaignTemplateCategoryTab ref={tabRef} autoSelected onChange={handleChange} />
            </Center>
          )}
        </Transition>
      </Affix>
      <CampaignTemplateCategoryTab autoSelected onChange={handleChange} />
    </Group>
  )
}

export default CategoryAffixTab
